<template>

</template>

<script>
export default {
  data () {
    return {
      error: ''
    }
  },
  beforeCreate: function () {
    this.$nextTick(function () {
      this.$auth.logout({
        makeRequest: true,
        url: BASE_URL + 'v1/auth/logout/',
        success: function () {
              this.$notify({
                title: 'Success',
                message: 'You have successfully logged out.',
                type: 'success'
            });
          console.log('success')
          localStorage.removeItem("user")

        },
        error: function () {
          console.log('failed')
        },
        redirect: '/'
      })
    })
  }
}
</script>


// WEBPACK FOOTER //
// Logout.vue?29ce7b3c